import { NgModule } from "@angular/core";
import { FormsModule } from '@angular/forms';
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

import { UserCreateComponent } from "./user-create.component";
import { SelectModule } from "ng2-select";

@NgModule({
    declarations: [
      UserCreateComponent
    ],
    imports: [
      FormsModule,
      CommonModule,
      RouterModule,
      SelectModule
    ],
    entryComponents: [
      UserCreateComponent
    ]
})
export class UserCreateModule { }



// WEBPACK FOOTER //
// /app/SPA/src/app/client/admin/user/create/user-create.module.ts